import { ReactNode, useEffect } from 'react'

import { useCheckedIds, checkSimpleStore } from 'app/common/templates-next/table-template'

export const PinnedDishesState = ({
  children,
}: {
  children: ({ pinnedDishesIds }: { pinnedDishesIds: Array<string> }) => ReactNode
}) => {
  useEffect(() => {
    return () => checkSimpleStore.reset()
  }, [])

  const pinnedDishesIds = useCheckedIds()
  return children({ pinnedDishesIds })
}
